const handleToolTip = () => {

    $(document).ready(function() {
        $(".tip").tooltip();
    });
}

handleToolTip();

